import React from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Package, ShoppingBag, MessageSquare, LogOut } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';

const navItem =
  'flex items-center gap-3 px-4 py-3 rounded-md text-sm font-medium transition-colors';

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    toast.success('Déconnexion réussie');
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className="w-64 bg-[#111] text-white flex flex-col">
        <Link to="/admin" className="p-6 border-b border-gray-800">
          <div className="text-xl font-bold tracking-wider">
            NEO<span className="text-[#E42313]">PLIAGE</span>
          </div>
          <div className="text-xs text-gray-400 mt-1">Administration</div>
        </Link>

        <nav className="flex-1 p-4 space-y-1">
          <NavLink
            to="/admin"
            end
            data-testid="admin-nav-dashboard"
            className={({ isActive }) =>
              `${navItem} ${isActive ? 'bg-[#E42313] text-white' : 'text-gray-300 hover:bg-gray-800'}`
            }
          >
            <LayoutDashboard className="w-5 h-5" /> Tableau de bord
          </NavLink>
          <NavLink
            to="/admin/produits"
            data-testid="admin-nav-products"
            className={({ isActive }) =>
              `${navItem} ${isActive ? 'bg-[#E42313] text-white' : 'text-gray-300 hover:bg-gray-800'}`
            }
          >
            <Package className="w-5 h-5" /> Produits
          </NavLink>
          <NavLink
            to="/admin/commandes"
            data-testid="admin-nav-orders"
            className={({ isActive }) =>
              `${navItem} ${isActive ? 'bg-[#E42313] text-white' : 'text-gray-300 hover:bg-gray-800'}`
            }
          >
            <ShoppingBag className="w-5 h-5" /> Commandes
          </NavLink>
          <NavLink
            to="/admin/messages"
            data-testid="admin-nav-messages"
            className={({ isActive }) =>
              `${navItem} ${isActive ? 'bg-[#E42313] text-white' : 'text-gray-300 hover:bg-gray-800'}`
            }
          >
            <MessageSquare className="w-5 h-5" /> Messages
          </NavLink>
        </nav>

        <div className="p-4 border-t border-gray-800">
          <div className="text-xs text-gray-400 mb-1">Connecté en tant que</div>
          <div className="text-sm font-medium truncate" data-testid="admin-user-email">
            {user?.email}
          </div>
          <button
            data-testid="admin-logout-btn"
            onClick={handleLogout}
            className="mt-3 w-full flex items-center gap-2 px-3 py-2 bg-gray-800 hover:bg-[#E42313] rounded text-sm transition-colors"
          >
            <LogOut className="w-4 h-4" /> Déconnexion
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
